var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieOutside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M17 4.375H13C12.585 4.375 12.25 4.04 12.25 3.625C12.25 3.21 12.585 2.875 13 2.875H17C17.415 2.875 17.75 3.21 17.75 3.625C17.75 4.04 17.415 4.375 17 4.375Z",
    fill: "#AFB8C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M19 7.125H13C12.585 7.125 12.25 6.79 12.25 6.375C12.25 5.96 12.585 5.625 13 5.625H19C19.415 5.625 19.75 5.96 19.75 6.375C19.75 6.79 19.415 7.125 19 7.125Z",
    fill: "#AFB8C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M15 14C15 18.14 11.64 21.5 7.5 21.5C3.36 21.5 0 18.14 0 14C0 9.86 3.36 6.5 7.5 6.5V14H15Z",
    fill: "#D0D7DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M15 14C15 9.86 11.64 6.5 7.5 6.5V14H15Z",
    fill: "#AFB8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieOutside);
export default __webpack_public_path__ + "static/media/pie-outside.20059e37be44d246d2eecb76e0f885d9.svg";
export { ForwardRef as ReactComponent };